import { inject } from "@angular/core";
import { createEffect, Actions, ofType } from "@ngrx/effects";
import { cameraActions } from "../camera/camera.actions";
import { Store } from "@ngrx/store";
import { UsersActions } from "./usersActions";
import { switchMap, combineLatest, filter, map, withLatestFrom } from "rxjs";
import { Vector3 } from "three/src/math/Vector3.js";
import { EventsWebsocketService } from "../../services/entities/events-websocket.service";
import { entityActions } from "../entities/entity.actions";
import { generateUUID } from "three/src/math/MathUtils.js";
import { CollisionType, Components, EntityType } from "../entities/entity.model";
import { LookingAtProperties } from "../entities/component-properties-dto/looking-at.properties.dto";
import { selectUserAvatarId } from "../auth/auth.selector";
import {UsersService} from "../../services/users.service";


export const getNewlySubscribedUser = createEffect(
  (
      actions$ = inject(Actions),
      usersService = inject(UsersService),
  ) => {
    return actions$.pipe(
      ofType(UsersActions.subscribeToUser),
      map(async (action) => {
          await usersService._getUser(action.userId)
      }),
    );
  },
  { functional: true, dispatch: false },
);
